// src/app/guards/auth.guard.ts
import { inject, Injectable } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { map, Observable, of } from 'rxjs';
import { CanActivateFn, Router } from '@angular/router';

//@Injectable({
//  providedIn: 'root'
//})

//export const authGuard: CanActivateFn = (route, state) => {
//  debugger;
//  return true;
//}

export const AuthGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  const user$ = new Observable<any>(subscriber => {
    onAuthStateChanged(auth, (user) => {
      subscriber.next(user);
    });
  });

  return user$.pipe(
    map(user => {
      if (!user) {
        router.navigate(['/tabs/tab2']);
        return false;
      }
      return true;
    })
  );
};


/*export class AuthGuard {
  private isAuthenticated = signal(false);

  constructor(private auth: Auth, private router: Router) {
    onAuthStateChanged(this.auth, (user) => {
      this.isAuthenticated.set(!!user);
    });
  }

  // Use this method in routing configuration
  canAccess() {
    if (!this.isAuthenticated()) {
      this.router.navigate(['/login']);
    }
    return this.isAuthenticated();
  }
}*/